import React, { useState } from 'react';
import Toast from './Toast';

function InfoCard({ type, person }) {
  const [showToast, setShowToast] = useState(false);

  if (!person) return null;

  const copyToClipboard = (text) => {
    if (text != null && text !== '') {
      navigator.clipboard.writeText(String(text));
      setShowToast(true);
    }
  };

  const CopyButton = ({ text }) => (
    <button className="cp" onClick={() => copyToClipboard(text != null ? text : '')}>
      📋
    </button>
  );

  // Safe getters for potentially undefined person data
  const safe = (val, fallback = '') => val != null ? val : fallback;

  if (type === 'id') {
    return (
      <>
        <div className="card id-card">
          <div className="hd">
            <div className="hd-title">T.C. ID Information</div>
            <div className="hd-icon">TR</div>
          </div>
          <div className="f">
            <div className="f-l">Full Name</div>
            <div className="f-v big">
              <span>{(person.name || '').toUpperCase()}</span>
              <CopyButton text={person.name} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">ID Number</div>
            <div className="f-v mono">
              <span>{safe(person.tc)}</span>
              <CopyButton text={person.tc} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Birth Date</div>
            <div className="f-v">
              <span>{safe(person.birth)}</span>
              <CopyButton text={person.birth} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Address</div>
            <div className="f-v sm">
              <span>{safe(person.addr)}</span>
              <CopyButton text={person.addr} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Phone</div>
            <div className="f-v">
              <span>{safe(person.phone)}</span>
              <CopyButton text={person.phone} />
            </div>
          </div>
        </div>
        {showToast && <Toast message="Copied to clipboard!" onClose={() => setShowToast(false)} />}
      </>
    );
  }

  if (type === 'bank') {
    return (
      <>
        <div className="card bank-card">
          <div className="hd">
            <div className="hd-title">Cenoa Bank</div>
            <div className="hd-icon">🏦</div>
          </div>
          <div className="f">
            <div className="f-l">Account Holder</div>
            <div className="f-v big">
              <span>{(person.name || '').toUpperCase()}</span>
              <CopyButton text={person.name} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Routing Number</div>
            <div className="f-v mono">
              <span>{safe(person.routingNum)}</span>
              <CopyButton text={person.routingNum} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Account Number</div>
            <div className="f-v mono">
              <span>{safe(person.accountNum)}</span>
              <CopyButton text={person.accountNum} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Password</div>
            <div className="f-v mono">
              <span>{safe(person.bankPass)}</span>
              <CopyButton text={person.bankPass} />
            </div>
          </div>
        </div>
        {showToast && <Toast message="Copied to clipboard!" onClose={() => setShowToast(false)} />}
      </>
    );
  }

  if (type === 'credit') {
    // Safely format card number
    let cardFormatted = '';
    if (person.cardNum) {
      const cardStr = person.cardNum.toString();
      const groups = cardStr.match(/.{1,4}/g);
      cardFormatted = groups ? groups.join(' ') : cardStr;
    }

    return (
      <>
        <div className="card credit-card">
          <div className="hd">
            <div className="hd-title">RedotPay</div>
            <div className="hd-icon">Credit</div>
          </div>
          <div className="f">
            <div className="f-l">Card Number</div>
            <div className="cc-num">
              <span>{cardFormatted}</span>
              <CopyButton text={person.cardNum} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
            <div className="f" style={{ marginBottom: 0 }}>
              <div className="f-l">Valid Thru</div>
              <div className="f-v mono">
                <span>{safe(person.cardExp)}</span>
                <CopyButton text={person.cardExp} />
              </div>
            </div>
            <div className="f" style={{ marginBottom: 0 }}>
              <div className="f-l">CVV</div>
              <div className="f-v mono">
                <span>{safe(person.cardCVV)}</span>
                <CopyButton text={person.cardCVV} />
              </div>
            </div>
          </div>
          <div className="f" style={{ marginTop: '8px' }}>
            <div className="f-l">Wallet Address</div>
            <div className="f-v sm mono">
              <span>{safe(person.crypto)}</span>
              <CopyButton text={person.crypto} />
            </div>
          </div>
        </div>
        {showToast && <Toast message="Copied to clipboard!" onClose={() => setShowToast(false)} />}
      </>
    );
  }

  if (type === 'server') {
    return (
      <>
        <div className="card server-card">
          <div className="hd">
            <div className="hd-title">Server Information</div>
            <div className="hd-icon">🖥️</div>
          </div>
          <div className="srv-icon">🔐</div>
          <div className="f">
            <div className="f-l">Server IP</div>
            <div className="f-v mono">
              <span>{safe(person.srvIP)}</span>
              <CopyButton text={person.srvIP} />
            </div>
          </div>
          <div className="f">
            <div className="f-l">Password</div>
            <div className="f-v mono">
              <span>{safe(person.srvPass)}</span>
              <CopyButton text={person.srvPass} />
            </div>
          </div>
        </div>
        {showToast && <Toast message="Copied to clipboard!" onClose={() => setShowToast(false)} />}
      </>
    );
  }

  return null;
}

export default InfoCard;